// extracted by mini-css-extract-plugin
module.exports = {"btn":"MovieReviews_btn__34ueN"};